<div class="card-vaga">
  <div class="card-vaga-logo">
    <a href="{{ urlVaga }}" target="_blank" class="card-vaga-link">
      <img [src]="urlImagem" />
    </a>
  </div>
  <div class="card-vaga-content">
    <p class="card-vaga-title">
      {{ preventWrongWrapping(titulo) | truncate : ["40", "..."] | titlecase }}
    </p>
    <p class="card-vaga-subtitle">
      {{ empresa | truncate : ["40", "..."] | titlecase }}
    </p>
    <p class="card-vaga-subtitle">{{ localVaga }}</p>
  </div>
  <div class="card-vaga-bottom">
    <div class="card-vaga-button">
      <a href="{{ urlVaga }}" target="_blank" class="card-vaga-link">
        Cadastre-se agora
      </a>
    </div>
    <p class="card-vaga-maisvagas">
      <a href="{{ siteUrl }}/vagas/{{ empresa }}" class="card-vaga-link">
        Conheça mais vagas desta empresa
      </a>
    </p>
  </div>
</div>
